// extracted by mini-css-extract-plugin
export default {"root":"hAtqBflm","title":"jPoVvDs9","paragraph":"GmdVqH1G","divider":"V2rgHmVm","button":"symNNY4F","confirmModal":"gaQjdQaH","icon":"q_mVUU4U"};